import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  private readonly document = inject<Document>(DOCUMENT);

  imageToFormData(image: any, name: string) {
    const base64ImageContent = image.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
    const blob = this.base64ToBlob(base64ImageContent, 'image/jpeg');
    const formData = new FormData();
    formData.append(name, blob);

    return formData;
  }

  base64ToBlob(base64: any, mime: any) {
    mime = mime || '';
    const sliceSize = 1024;
    const byteChars = window.atob(base64);
    const byteArrays = [];

    for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
      const slice = byteChars.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mime });
  }

  routeParams(activatedRoute: ActivatedRouteSnapshot | ActivatedRoute): Params {
    let route = activatedRoute.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.params;
  }

  arrayToPairwise(arr: any[]): any[] {
    const objs = arr.reduce((result, value, index, array) => {
      if (index % 2 === 0) {
        result.push(array.slice(index, index + 2));
      }
      return result;
    }, []);

    return objs;
  }

  parseQuery(queryString: string): { [key: string]: string } {
    const query: { [key: string]: string } = {};
    const pairs = (queryString[0] === '?' ? queryString.slice(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  isEmptyObject(obj: any): boolean {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  scriptExists(src: string) {
    const scripts = this.document.getElementsByTagName('script');
    for (let i = scripts.length; i--; ) {
      if (scripts[i].src?.indexOf(src) > -1) {
        return true;
      }
    }
    return false;
  }
}
